export function EtapaCompradorSkeleton() {
  return (
    <div className="mt-6 py-0 pb-0 sm:py-4">
      <div className="mx-auto max-w-6xl bg-white p-6">
        <div className="mb-6 flex items-end justify-between space-y-2">
          <div className="flex flex-col">
            <div className="mb-2 h-5 w-48 animate-pulse rounded bg-gray-200" />
            <div className="h-4 w-64 animate-pulse rounded bg-gray-200" />
          </div>
          <div className="flex items-center">
            <div className="h-10 w-40 animate-pulse rounded-md bg-gray-200" />
          </div>
        </div>

        <div className="mt-6 flex flex-wrap gap-4 border-none">
          <div className="mb-6 flex min-h-96 w-full flex-col items-center justify-center">
            <div className="mx-auto mb-4 flex h-20 w-20 animate-pulse items-center justify-center rounded-full bg-gray-200">
              <div className="h-10 w-10 rounded bg-gray-300" />
            </div>
            <div className="mb-2 h-6 w-48 animate-pulse rounded bg-gray-200" />
            <div className="mb-6 h-4 w-72 animate-pulse rounded bg-gray-200" />
          </div>
        </div>

        <div className="-mx-6 mt-8 max-w-6xl border-t bg-white">
          <div className="mx-6 flex justify-between pt-4">
            <div className="h-10 w-32 animate-pulse rounded-md bg-gray-200" />
            <div className="h-10 w-32 animate-pulse rounded-md bg-gray-200" />
          </div>
        </div>
      </div>
    </div>
  )
}
